import { Avatar, Button, Grid, Typography } from '@mui/material';
import { IPointOfSaleItem, IReservation, IRoom } from '../../../interfaces/IPartnerPms';
import { useCallback, useMemo } from 'react';
import { useLanguageContext } from '../../../contexts/LanguageContext';
import DefaultConstants from '../../../data/Constants';
import { ActionButton } from '../../Button';
import Dialog, { IDefaultDialogProps } from '../../Dialog';
import FormHelper from '../../../helpers/FormHelper';
import PartnerPmsService from '../../../services/PartnerPmsService';
import { Delete } from '@mui/icons-material';
import { useAuthContext } from '../../../contexts/AuthContext';
import PointOfSaleItemsList from '../../ItemsList/PointOfSaleItemsList';


interface IViewShoppingCartDialogProps extends IDefaultDialogProps {
    shoppingCart: IPointOfSaleItem[];
    handleRemoveItem: (item: IPointOfSaleItem) => void;
    handleSubmitSuccess: () => void;
    room: IRoom;
    reservation: IReservation;
}


const ViewShoppingCartDialog: React.FC<IViewShoppingCartDialogProps> = ({
    open,
    handleClose,
    shoppingCart,
    handleRemoveItem,
    handleSubmitSuccess,
    room,
    reservation
}) => {
    const { translate } = useLanguageContext();
    const { enterprise } = useAuthContext();


    const handleSubmit = useCallback((event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        let formData = FormHelper.Create(event);
        formData = FormHelper.Add(formData, 'pointOfSaleId', enterprise?.roomServicePointOfSaleId);
        formData = FormHelper.Add(formData, 'roomDescription', room.description);
        formData = FormHelper.Add(formData, 'reservationId', reservation.id);
        formData = FormHelper.Add(formData, `items`, JSON.stringify(shoppingCart));

        PartnerPmsService.LaunchPointOfSaleItems(formData).then(() => {
            handleClose();
            handleSubmitSuccess();
        });

        // eslint-disable-next-line
    }, [enterprise, shoppingCart, room, reservation]);


    const dialogActions = useMemo(() => {
        return [
            <ActionButton action='no' onClick={handleClose} />,
            <ActionButton action='yes' type='submit' />
        ];
        // eslint-disable-next-line
    }, [translate]);

    
    return (
        <>
            <Dialog
                open={open}
                handleClose={handleClose}
                title={translate('shoppingCart')}
                dialogActions={dialogActions}
                onSubmit={handleSubmit}
                className='dialogactions-spacebetween overflow-inherit'
                absolute={true}
                dividers={true}
            >
                <Grid container rowSpacing={DefaultConstants.gridRowSpacing} columnSpacing={DefaultConstants.gridColumnSpacing}>
                    <Grid item xs={12}>
                        <Typography variant='body1'> {translate('_governanceDialogSaveShoppingCartDescription')} </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <PointOfSaleItemsList 
                            items={shoppingCart}
                            avatar={item => {
                                return <Avatar className='backgroundcolor-primary fontsize-16'> 
                                    {item.amount}x 
                                </Avatar>;
                            }}
                            actions={item => {
                                return <Button 
                                    className='item-action color-red' 
                                    onClick={() => handleRemoveItem(item)}
                                >
                                    <Delete />
                                </Button>;
                            }}
                        />
                    </Grid>
                </Grid>
            </Dialog>
        </>
    );
}

export default ViewShoppingCartDialog;